<template>
  <div>
    <div class="top-bar">
      <span class="top-bar-text map-text font-bold">SALUTEAI</span>
    </div>
    <div class="relative header-img">
      <img class="header-img" :src="header" alt="" />
      <!-- <div class="map-title-ab absolute"></div> -->
      <div class="header-text absolute">
        <div class="text">
          <h2 class="map-text font-bold">Mobile App Marketing Agency</h2>
          <div class="text-center map-text mt20">
            <span>We are a mobile-first marketing agency.</span><br />
            <span>We help businesses grow using the full power of mobile devices and modern advertising technologies</span><br />
          </div>
        </div>
      </div>
      <div class="map-img-bg absolute"></div>
    </div>
    <div class="team">
      <div>
        <img class="team-img" :src="img0202" alt="" />
      </div>
      <div class="team-left">
        <h3 class="team-title font-bold">Technology</h3>
        <div class="team-text map-text font-regular">
          With over 10 years experience in mobile advertising industry, we’ve built our own technology specifically for the mobile consumer in mind. We understand how to reach the demanding targets set within a saturated and competitive environment. Our sophisticated solutions work alongside each other to make it simple for advertisers, agencies and publishers to create real connections. Expect more revenue channels, better engagement and cooler, more interactive ads.
        </div>
        <h3 class="team-title font-bold">Trust</h3>
        <div class="team-text map-text font-regular">
          At our core, we’re about building relationships—both with our partners and their consumers. SaluteAI’s global teams provide full support to not only provide the best solutions, but the best experience as our partners execute their mobile strategy. We understand that this level of trust extends to their target audiences, which is why our product suite is tailored to create more value for the user.
        </div>
        <h3 class="team-title font-bold">Team</h3>
        <div class="team-text map-text font-regular">
          Products are amplified by people, and at SaluteAI, the most effective tech is brought to you by the most experienced and dedicated team. With employees in multiple countries speaking various languages, and offices in Hong Kong, Beijing, Singapore. SaluteAI combines an experienced global workforce with local market expertise.
        </div>
      </div>
    </div>
    <div class="global">
      <div class="global-hader">
        <div class="global-left">
          <h3 class="global-title font-bold">About us</h3>
          <div class="global-text map-text font-regular">
            Mobile in-app advertising is a fast-iteratived and increasingly sophisticated industry. With the key players—from app developers to mobile advertising agencies—everyone is looking to find the most effective and efficient ways to reach their target audience. Together, we will continue to aim for a positive, comfortable experience and pave the path toward a more normative industry. The first step toward achieving this is to empower your team with the right set of ad tech tools customized to create and optimize the impact of your mobile strategy.
            At SaluteAI, our people and tech set us apart, providing a transparent and trustworthy line of communication with our partners.
          </div>
        </div>
        <div style="margin: auto">
          <img class="global-img" :src="global" alt="" />
        </div>
      </div>
    </div>
    <div class="introduce">
      <h3 class="intro-title font-bold">DATA-DRIVER PERFORMANCE EXPERTISE</h3>
      <div class="map-text font-regular">We are proud to partner with all major mobile measurement partners.</div>
      <!-- 第一个 -->
      <div>
        <div class="introduce-index relative">
          <img class="img4 absolute" :src="img4" alt="" />
          <div class="bg1 introduce-b1"></div>
          <div class="bg2 introduce-b2 absolute">
            <div>
              <h3 class="title-text font-bold">Media promotion content protection</h3>
              <div class="map-text font-regular">SaluteAI warrants that the services (and/or the Media Space) will not be identified with any objectionable content, including but not limited to content that is unlawful, pornographic, obscene or defamatory, likely to cause wide-spread or serious offense, promotes illegal activities, advocates or endorses discrimination on the basis of race, ethnicity, gender, religion, sexual orientation or class.</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第二个 -->
      <div class="introduce2">
        <div class="introduce-index1 relative">
          <img class="img5 absolute" :src="img5" alt="" />
          <div class="bg4 introduce-b1"></div>
          <div class="bg3 introduce-b3 absolute">
            <div>
              <h3 class="title-text font-bold">Anti-Fraud Strategy</h3>
              <div class="map-text font-regular">As important component of SaluteAI Anti-fraud power, QI team quite understand abnormal performance fraud traffic caused. We seriously inspect campaign for clients by more than 20 dimensions about fraud character we had accumulated. 
                Based on self-developed Event  system, we can spy data for key event advertiser cares in Real-Time. Once we detect abnormal performance, we will take action asap. </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第三个 -->
      <div>
        <div class="introduce-index2 relative">
          <img class="img6 absolute" :src="img6" alt="" />
          <div class="bg6 introduce-b4"></div>
          <div class="bg5 introduce-b5 absolute">
            <div>
              <h3 class="title-text font-bold">Programatic advertising</h3>
              <div class="map-text font-regular">SaluteAI Provides 10+ ad formats, including rewarded video ad, native video ad, pre-roll ad, native feeds ad, native app walls, full-screen splash ad, interstitial ad, banner ad, etc.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="map">-->
<!--      <div class="global-map">-->
<!--        <h3 class="font-bold">COOPERATION CUSTOMER CASE</h3>-->
<!--        <div class="map-text font-regular">Dedicated to your success</div>-->
<!--        <div class="flex-user-hader">-->
<!--          <div-->
<!--            class="user-hader"-->
<!--            v-for="(item, index) in userList"-->
<!--            :key="index"-->
<!--          >-->
<!--            <img class="user-img" :src="item.img" alt="" />-->
<!--            <div class="text-center mt6">{{ item.title }}</div>-->
<!--            <div class="text-center mt10">{{ item.text1 }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="map">-->
<!--      <div class="global-map">-->
<!--        <h3>About us</h3>-->
<!--        <div class="map-text">Harnessed for productivity.</div>-->
<!--        <div>-->
<!--          <img class="map-img" :src="globalUrl" alt="" />-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="app-hader-index">
      <div class="app-hader">
        <div class="app-hader-left">
          <h3 class="app-title font-bold">SALUTEAI DSP</h3>
          <div class="map-text font-regular">Programmatic Ad Platform</div>
          <div class="jianbian font-regular">Access to nearly 20 global ad exchanges</div>
          <div class="app-img-hader">
            <img class="app-img1" :src="imgList2[0].img" alt="" />
            <img class="app-img2" :src="imgList2[1].img" alt="" />
            <img class="app-img3" :src="imgList2[2].img" alt="" />
            <img class="app-img4" :src="imgList2[3].img" alt="" />
            <img class="app-img5" :src="imgList2[4].img" alt="" />
            <img class="app-img6" :src="imgList2[5].img" alt="" />
            <img class="app-img7" :src="imgList2[6].img" alt="" />
            <img class="app-img8" :src="imgList2[7].img" alt="" />
          </div>
        </div>
        <div class="app-hader-left">
          <h3 class="app-title font-bold">SALUTEAI SSP</h3>
          <div class="map-text font-regular">Al-Driven Interactive Ad Platform</div>
          <div class="jianbian font-regular">Partners with 5,300+ Apps</div>
          <div class="app-img-hader">
            <div class="app-img" v-for="(item, index) in imgList3" :key="index">
              <img class="app-img9" :src="item.img" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="map">
      <div class="global-map">
        <h3 class="partner-title font-regular">We are proud to partner with all major mobile measurement partners.</h3>
        <div class="bottom-user-hader">
          <div class="bottom-user-img" v-for="(item,index) in imgList4" :key="index">
            <img class="img10" :src="item.img" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      logo: require("@/assets/img/SaluteAI-07.png"),
      header: require("@/assets/img/header.jpg"),
      global: require("@/assets/img/global.jpg"),
      globalUrl: require("@/assets/img/globalUrl.png"),
      img4: require("@/assets/img/img4.jpg"),
      img5: require("@/assets/img/img5.jpg"),
      img6: require("@/assets/img/img6.jpg"),
      img0202: require("@/assets/img/img-02-2.png"),
      imgList1: [
        {
          img: require("@/assets/img/img1.png"),
          title: "Data Driven",
          text1: "Harnessed productivity. Designed for",
        },
        {
          img: require("@/assets/img/img2.png"),
          title: "Data Driven",
          text1: "Harnessed productivity. Designed for",
        },
        {
          img: require("@/assets/img/img3.png"),
          title: "Data Driven",
          text1: "Harnessed productivity. Designed for",
        },
      ],
      imgList2: [
        {
          img: require("@/assets/img/dsp/dsp (1).png"),
        },
        {
          img: require("@/assets/img/dsp/dsp (2).png"),
        },
        {
          img: require("@/assets/img/dsp/dsp (4).png"),
        },
        {
          img: require("@/assets/img/dsp/dsp (7).png"),
        },
        {
          img: require("@/assets/img/dsp/dsp (3).png"),
        },
        {
          img: require("@/assets/img/dsp/dsp (6).png"),
        },
        {
          img: require("@/assets/img/dsp/dsp (5).png"),
        },
        {
          img: require("@/assets/img/dsp/dsp (8).png"),
        },
      ],
      imgList3: [
        {
          img: require("@/assets/img/app/图片9.png"),
        },
        {
          img: require("@/assets/img/app/图片13.png"),
        },
        {
          img: require("@/assets/img/app/图片14.png"),
        },
        {
          img: require("@/assets/img/app/图片12.png"),
        },
        {
          img: require("@/assets/img/app/图片15.png"),
        },
        {
          img: require("@/assets/img/app/图片16.png"),
        },
        {
          img: require("@/assets/img/app/图片17.png"),
        },
        {
          img: require("@/assets/img/app/图片10.png"),
        },
        {
          img: require("@/assets/img/app/图片11.png"),
        },
      ],
      imgList4: [
        {
          img: require("@/assets/img/qu-dao/q (3).png"),
        },
        {
          img: require("@/assets/img/qu-dao/q (4).png"),
        },
        {
          img: require("@/assets/img/qu-dao/q (5).png"),
        },
        {
          img: require("@/assets/img/qu-dao/q (6).png"),
        },
        {
          img: require("@/assets/img/qu-dao/q (1).png"),
        },
        {
          img: require("@/assets/img/qu-dao/q (2).png"),
        }
      ],
      userList: [
        {
          img: require("@/assets/img/user-img1.jpg"),
          title: "Data",
          text1: "Harnessed",
        },
        {
          img: require("@/assets/img/user-img2.jpg"),
          title: "Data",
          text1: "Harnessed",
        },
        {
          img: require("@/assets/img/user-img3.jpg"),
          title: "Data",
          text1: "Harnessed",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../assets/font/font.css";
  .font-bold{
    font-family: 'manrope-bold';
  }
  .font-regular{
    font-family: 'manrope-regular';
  }
  .top-bar{
    width: 100%;
    height: 10px;
    background-color:rgba(0,0,0,0.5);
    position: absolute;
    z-index: 100;
    text-align: center;
  }
  .top-bar-text{
    color: #fff;
  }
.app-hader-index{
  background: rgb(231, 191, 191);
  padding: 20px 0 10px;
}
.app-hader {
  width: 290px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.app-hader-left {
  width: 46%;
  text-align: center;
}
.app-img-hader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.app-title {
  font-size: 7px !important;
}
.jianbian{
  background: linear-gradient(to right,rgb(240, 111, 111),rgb(236, 235, 137));
  width: 100%;
  height: 10px;
  line-height: 10px;
  border-radius: 20px;
  color: #fff;
  margin: 1px 0;
}
.app-img {
  width: 33%;
  margin-bottom: 10px;
}
.bottom-user-hader{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.bottom-user-img{
  width: 25%;
  margin-top: 20px;
}
.img10{
  width: 60px;
  object-fit: fill;
}
.app-img9 {
  width: 30px;
  object-fit: fill;
}
.app-img1 {
  height: 12px;
  object-fit: fill;
  margin-bottom: 16px;
}
.app-img2 {
  height: 16px;
  object-fit: fill;
  margin-bottom: 16px;
}
.app-img3 {
  height: 18px;
  object-fit: fill;
  margin-bottom: 16px;
}

.app-img4 {
  height: 18px;
  object-fit: fill;
  margin-bottom: 16px;
}
.app-img5 {
  height: 10px;
  object-fit: fill;
  margin-bottom: 16px;
}
.app-img6 {
  height: 12px;
  margin-bottom: 16px;
  object-fit: fill;
}
.app-img7 {
  height: 18px;
  margin-bottom: 16px;
  object-fit: fill;
}
.app-img8 {
  height: 18px;
  margin-bottom: 16px;
  object-fit: fill;
}
h2,
h3 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
}
.title-text {
  font-size: 7px !important;
  transform: scale(0.85);
  line-height: 10px;
  font-weight: 600;
}
.mt6 {
  margin-top: 6px;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.map-img-bg {
  background: #000;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  top: 0;
  left: 0;
}
.header-text {
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 9;
}
.header-text > .text {
  color: #fff;
  padding-left: 100px;
  width: 100px;
}
.header-text > .text > .text-center {
  margin-top: 10px;
  font-size: 12px;
}
.map-title-ab {
  top: 0;
  left: 0;
  width: 100%;
  height: 20px;
  background-color: rgb(255, 255, 255, 0.25);
}
.header-img {
  width: 100%;
  height: 230px;
}
.direction {
  color: #333;
  background: rgb(238, 243, 247);
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.direction-header {
  width: 260px;
  display: flex;
  justify-content: space-between;
}
.direction-list {
  width: 30%;
  text-align: center;
}
.direction img {
  width: 60px;
  height: 60px;
}

.direction .img {
  display: flex;
  justify-content: center;
}
.global {
  padding: 20px 0;
  color: #fff;
  display: flex;
  justify-content: center;
  background: rgb(035, 051, 064);
}
.global-hader {
  width: 300px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
}
.global-left {
  width: 180px;
}
.global-text {
  width: 180px;
}
.global-title {
  padding-left: 14px;
}
.global-img {
  width: 120px;
}

.team {
  padding: 20px 0;
  /*color: #fff;*/
  display: flex;
  justify-content: center;
  background: rgb(238, 243, 247);
}
.team-hader {
  width: 300px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
}
.team-left {
  width: 180px;
}
.team-text {
  width: 200px;
}
.team-title {
  padding-left: 14px;
}
.team-img {
  width: 120px;
}

.map {
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 20px;
}
.global-map {
  text-align: center;
  width: 260px;
}
.map-text {
  font-size: 5px !important;
  transform: scale(0.85);
  line-height: 9px;
}
.map-img {
  width: 100%;
  margin-top: 10px;
}
.introduce {
  text-align: center;
  background: rgb(238, 243, 247);
  padding: 20px 0 0;
}
.intro-title {
  font-size: 10px !important;
}
.introduce-index {
  margin-top: 10px;
  height: 140px;
  width: 280px;
  display: flex;
  align-items: flex-end;
}
.introduce2 {
  display: flex;
  justify-content: flex-end;
}

.introduce-index1 {
  margin-top: 10px;
  height: 140px;
  width: 280px;
  display: flex;
  align-items: flex-end;
}
.introduce-index2 {
  margin-top: 10px;
  height: 140px;
  width: 100%;
  display: flex;
  align-items: flex-end;
}
.img4 {
  width: 180px;
  top: 0;
  right: 40px;
}
.introduce-b1 {
  width: 280px;
  height: 100px;
}
.introduce-b2 {
  width: 130px;
  height: 80px;
  top: 25px;
  right: -40px;
  display: flex;
  align-items: center;
  text-align: left;
  color: #fff;
}
.introduce-b4 {
  width: 100%;
  height: 100px;
}
.img5 {
  width: 180px;
  top: 0;
  left: 40px;
}
.img6 {
  width: 180px;
  top: 0;
  left: 60px;
}
.introduce-b3 {
  width: 130px;
  height: 80px;
  top: 25px;
  left: -40px;
  display: flex;
  align-items: center;
  text-align: left;
  color: #fff;
}
.introduce-b5 {
  width: 130px;
  height: 80px;
  top: 25px;
  right: 50px;
  display: flex;
  align-items: center;
  text-align: left;
  color: #fff;
}
.bg1 {
  background: rgb(186, 187, 189);
}
.bg2 {
  background: rgb(063, 059, 050);
}
.bg3 {
  background: rgb(051, 062, 054);
}
.bg4 {
  background: rgb(183, 189, 189);
}
.bg5 {
  background: rgb(051, 055, 064);
}
.bg6 {
  background: rgb(182, 185, 190);
}
.flex-user-hader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.user-hader {
  width: 80px;
  height: 90px;
  padding: 10px 0;
  box-shadow: 0px -1px 2px 0px #f6f6f6, -2px 0px 2px 0px #f6f6f6,
    2px 0px 2px 0px #f6f6f6, 0px 2px 2px 0px #f6f6f6;
}
.user-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
}
  .partner-title{
    font-size: 6px !important;
  }
</style>
